import { render, staticRenderFns } from "./CloudPms.vue?vue&type=template&id=0b97b169&scoped=true&"
import script from "./CloudPms.vue?vue&type=script&lang=js&"
export * from "./CloudPms.vue?vue&type=script&lang=js&"
import style0 from "./CloudPms.vue?vue&type=style&index=0&id=0b97b169&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b97b169",
  null
  
)

export default component.exports